import TextField from '@mui/material/TextField'
import { validatePassword } from '../utils/passwordValidation'

interface PasswordFieldProps {
  value: string
  onChange: (value: string, errors: string[]) => void
  label?: string
  id?: string
  onEnter?: () => void
}

export default function PasswordField({
  value,
  onChange,
  label = 'Password',
  id = 'password',
  onEnter
}: PasswordFieldProps) {
  const errors = value ? validatePassword(value) : []

  return (
    <TextField
      id={id}
      label={label}
      type="password"
      variant="outlined"
      fullWidth
      required
      sx={{ mb: 2 }}
      error={errors.length > 0}
      helperText={
        errors.length > 0 
          ? errors.map((error, index) => (
              <span key={index}>
                {error}
                {index < errors.length - 1 && <br />}
              </span>
            ))
          : value.length === 0
            ? 'Must be at least 8 characters with uppercase, lowercase, number, and special character'
            : ''
      }
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value
        const validationErrors = newValue ? validatePassword(newValue) : []
        onChange(newValue, validationErrors)
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && onEnter) {
          onEnter()
        }
      }}
    />
  )
}

